import { CaretDownOutlined, CaretRightOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FlexWrapper } from '../../theme/common_style';

const Wrapper = styled.div`
  border: 1px solid transparent;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  margin-bottom: 20px;

  .title-name {
    width: 100%;
    font-size: 16px;
    font-weight: 600;
    font-family: Plus Jakarta Sans;
    text-align: left;
    display: flex;
    gap: 10px;
    justify-content: space-between;
  }
  @media (max-width: 668px) {
    flex-direction: column-reverse;
    gap: 10px;
  }
`;

const Header = styled.div`
  background-color: #ffffff;
  padding: 12px 16px;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 520px) {
    flex-direction: column-reverse;
    align-items: start;
    justify-content: start;
    gap: 12px;
    .css-8kmmnd {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
  }
  .title-name {
    white-space: nowrap;
  }
`;

const Content = styled.div`
  max-height: ${({ expanded }) => (expanded ? '2500px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease;
  background-color: #ffffff;
`;

const ExpandCollapseWrapper = ({
  title = 'Toggle',
  children,
  defaultExpanded = true,
  content,
  reportingTime
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Wrapper>
      <Header expanded={expanded} onClick={() => setExpanded((prev) => !prev)}>
        <span>
          <span className="title-name">{title}</span>
          <SubmittedDate gap="6px" align="center" margin="4px 0 0">
            <span style={{ fontSize: '13px', color: '#888', whiteSpace: 'nowrap' }}>
              Submitted On:
            </span>
            {reportingTime}
          </SubmittedDate>
        </span>
        <FlexWrapper gap="15px">
          {content}{' '}
          {expanded ? (
            <CaretDownOutlined style={{ cursor: 'pointer' }} />
          ) : (
            <CaretRightOutlined style={{ cursor: 'pointer' }} />
          )}
        </FlexWrapper>
      </Header>
      <Content expanded={expanded}>{children}</Content>
    </Wrapper>
  );
};

export default ExpandCollapseWrapper;

ExpandCollapseWrapper.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  defaultExpanded: PropTypes.bool,
  content: PropTypes.node,
  reportingTime: PropTypes.node
};

export const SubmittedDate = styled.div`
  width: ${(props) => props.width};
  display: flex;
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: ${(props) => props.justify || 'start'};
  align-items: ${(props) => props.align || 'start'};
  gap: ${(props) => props.gap || '10px'};
  cursor: ${(props) => props.cursor || 'auto'};
  margin: ${(props) => props.margin || '0px'};

  @media (max-width: 668px) {
    padding: 0;
    align-items: start;
    flex-direction: column;
  }

  .hms-remark {
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
`;
